import React from 'react';
import { useTranslation } from 'react-i18next';
import { OperationSettlementStatusBarIcon } from './OperationSettlementStatusBarIcon';
import { Divider } from '../common/Divider';

interface OperationSettlementStatusBarProps {
  testId?: string;
  className?: string;
}

export enum OperationSettlementStatus {
  BeforeInvoiceIssuance = 'beforeInvoiceIssuance',
  InvoiceIssued = 'invoiceIssued',
  TaxInvoiceIssued = 'taxInvoiceIssued',
  SettlementCompleted = 'settlementCompleted',
}

export const OperationSettlementStatusBar: React.FC<
  OperationSettlementStatusBarProps
> = ({ testId, className }) => {
  const { t } = useTranslation();
  return (
    <div
      data-testid={testId}
      className={`noto-11-normal flex text-dark-9 ${className}`}
    >
      {Object.values(OperationSettlementStatus).map((status, index, array) => {
        const isLast = index === array.length - 1;

        return (
          <div key={index} className="flex items-center">
            <OperationSettlementStatusBarIcon
              text={(index + 1).toString().padStart(2, '0')}
            />
            <p className="ml-[3px] leading-[11px]">
              {t(`settlement.${status}`)}
            </p>
            {!isLast && (
              <Divider className="ml-[3px] mr-[5px] w-[14px] bg-light-6" />
            )}
          </div>
        );
      })}
    </div>
  );
};
